import React from 'react';
import styles from './ViewContainerTable.module.scss';
import ItemContainer from '../ItemContainer/ItemContainer';
import TableRso from '../../ui/TableRso/TableRso';

const ViewContainerTable = ({ form }) => {
  return (
    <div className={styles.root}>
      <ItemContainer form={form} />
      <TableRso form={form} />
    </div>
  );
};

export default ViewContainerTable;
